<template>
    <div class="relative">
        <a
            class="button w-full lg:w-auto pl-7 pr-6 border-none text-xl cursor-pointer"
            :class="this.bg ? 'bg-white' : 'bg-transparent'"
            @click.prevent="toggleShare()"
        >
            <svg :class="pageStyle ? `stroke-${pageStyle}-secondary` : (this.postType === 'experience' ? 'stroke-secondary' : 'stroke-dark')" width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.20368 2.83477C1.13612 6.53625 1.07002 10.2363 1.00247 13.9377C0.996591 14.2237 0.993655 14.5156 1.08618 14.7854C1.35935 15.5755 2.31252 15.86 3.13938 15.9646C4.88416 16.1858 6.65097 16.1062 8.40749 16.0251C11.3727 15.888 14.3394 15.7524 17.3047 15.6153C17.6704 15.5991 18.042 15.5799 18.3827 15.4487C19.1346 15.1598 19.5841 14.3918 19.8954 13.6473C21.2451 10.4132 21.063 6.76916 20.8574 3.26816C20.8398 2.97039 20.8163 2.6564 20.643 2.41464C20.4667 2.16847 20.1686 2.04612 19.8822 1.95031C18.1741 1.37835 16.3412 1.34886 14.5421 1.33412C10.3035 1.29727 5.99741 1.31496 1.20368 2.83477Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1.43262 3.34504C4.47483 5.46368 7.51704 7.58085 10.5608 9.69949C10.7714 9.8461 10.9971 9.99859 11.2559 10.0191C11.5432 10.0426 11.8156 9.89889 12.0638 9.75667C15.3979 7.8521 18.3137 5.25842 20.5631 2.19556" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <span class="pl-0.5" :class="pageStyle ? `text-${pageStyle}-secondary` : (this.postType === 'experience' ? 'text-secondary' : 'text-dark')"
            >
                Share This Page
            </span>
        </a>

        <div :class="(show) ? 'mt-4 border' : 'h-0'" class="absolute left-0 top-full z-10 flex justify-center items-center w-full min-w-64 px-8 border-none rounded-3xl bg-white  overflow-hidden transition-all">
            <a :href="'https://twitter.com/intent/tweet?url=' + url" target="_blank" title="X">
                <svg class="w-5 h-auto m-2 transition-transform hover:scale-110" width="1200" height="1227" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="#000000"/>
                </svg>                                  
            </a>

            <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + url" target="_blank" title="Facebook">
                <svg class="m-2 transition-transform hover:scale-110" width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24.4006 13.7241L22.5842 13.7253C21.1597 13.7253 20.8835 14.4088 20.8835 15.4115V17.6239H24.2812L23.8385 21.09H20.8835V29.9812H17.3411V21.09H14.3789V17.6239H17.3411V15.0691C17.3411 12.1025 19.1347 10.4883 21.7531 10.4883C23.0075 10.4883 24.0858 10.5821 24.4006 10.6247V13.7241Z"
                    fill="#000000"
                    />
                </svg>
            </a>

            <a :href="'https://api.whatsapp.com/send?text=' + url" target="_blank" title="WhatsApp">
                <svg class="relative left-1 top-1 m-2 transition-transform hover:scale-110" width="39" height="40" viewBox="0 0 39 40" fill="none">
                    <g><path class="relative left-1" d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z" fill="#000000" fill-rule="evenodd"></path></g>
                </svg>
            </a>

            <a v-if="!copied" class="flex items-center group cursor-pointer" @click.prevent="copyToClipboard()">
                <svg class="w-6 h-auto ml-4 mr-1 transition-transform group-hover:scale-110" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21 8C21 6.34315 19.6569 5 18 5H10C8.34315 5 7 6.34315 7 8V20C7 21.6569 8.34315 23 10 23H18C19.6569 23 21 21.6569 21 20V8ZM19 8C19 7.44772 18.5523 7 18 7H10C9.44772 7 9 7.44772 9 8V20C9 20.5523 9.44772 21 10 21H18C18.5523 21 19 20.5523 19 20V8Z" fill="#000000"/>
                    <path d="M6 3H16C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1H6C4.34315 1 3 2.34315 3 4V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V4C5 3.44772 5.44772 3 6 3Z" fill="#000000"/>
                </svg>

                <span class="pr-2 md:pr-0 text-black text-sm">Copy Link</span>
            </a>

            <span v-if="copied" class="flex items-center">
                <svg class="w-6 h-auto ml-4" width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.13319 7.94302C2.93319 7.94302 2.74419 7.86502 2.60319 7.72302L0.462188 5.58302C0.320188 5.44202 0.242188 5.25302 0.242188 5.05302C0.242188 4.85302 0.320188 4.66402 0.461188 4.52202C0.603188 4.38002 0.791188 4.30202 0.992188 4.30202C1.19219 4.30202 1.38119 4.38002 1.52219 4.52202L3.05119 6.05102L7.05219 1.04902C7.19319 0.861024 7.41819 0.749023 7.65219 0.749023C7.81519 0.749023 7.97019 0.801024 8.10119 0.898024C8.43219 1.14702 8.50019 1.61802 8.25219 1.94902L3.73219 7.64202C3.60119 7.81602 3.40219 7.92502 3.18519 7.94002C3.17119 7.94302 3.15219 7.94302 3.13319 7.94302Z" fill="#059669" />
                </svg>

                <span class="text-green-600 text-sm pr-2 md:pr-2">copied</span>
            </span>
        </div>
    </div>
</template>
<script>
export default {
	data() {
		return {
			show: false,
            url: window.location.href,
            copied: false,
		}
	},
    props: {
        bg: {
            type: Boolean,
            default: true,
        },
        postType: {
            type: String,
            default: 'post',
        },
        pageStyle: {
            type: String,
            default: '',
        },
    },
    methods: {
        toggleShare(){
            this.show = !this.show
        },
        copyToClipboard(){
            navigator.clipboard.writeText( this.url ).then(
                () => {
                    this.copied = true
                },
                () => {
                    console.error("Copy to Clipboard failed.")
                },
            );
        }
    },
}
</script>
